// weather data
export const LOAD_WEATHER_DATA_REQUEST = 'LOAD_WEATHER_DATA_REQUEST';
export const LOAD_WEATHER_DATA_SUCCESS = 'LOAD_WEATHER_DATA_SUCCESS';
export const LOAD_WEATHER_DATA_FAILURE = 'LOAD_WEATHER_DATA_FAILURE';

// Index of the selected day
export const CHANGE_SELECTED_DAY_INDEX = 'CHANGE_SELECTED_DAY_INDEX';

// Temperature Conversion
export const CONVERT_TEMP_TO_CELCIUS = 'CONVERT_TEMP_TO_CELCIUS';
export const CONVERT_TEMP_TO_FAHRENHEIT = 'CONVERT_TEMP_TO_FAHRENHEIT';
